import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import WebsitePackages from '../components/WebsitePackages';
import HostingPlans from '../components/HostingPlans';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
// import '../styles/LandingPage.css';

const LandingPage = () => {
    return (
    <div className="landing-page">
        <Header />
        <Hero />
        <WebsitePackages />
        <HostingPlans />
        <ContactForm />
        <Footer />
    </div>
    );
};

export default LandingPage;